import { Box } from "@mui/material";
import styled from "@emotion/styled";

export const Card = styled(Box)({
  borderRadius: "15px",
  background: "#1C1C1C",
  overflow: "hidden",
});
